import { render, staticRenderFns } from "./albumWorks.vue?vue&type=template&id=267d4826&"
import script from "./albumWorks.vue?vue&type=script&lang=js&"
export * from "./albumWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports